import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names with `clsx` (conditional/falsy-aware) and then resolves
 * conflicts via `tailwind-merge` so later Tailwind utilities beat earlier ones.
 *
 * This replaces My.Tms.Old's simple `classes.filter(Boolean).join(' ')` so we
 * stop accidentally shipping conflicting utilities like
 *   `cn('bg-blue-600', condition && 'bg-red-600')`
 * — `tailwind-merge` will keep only the last `bg-*`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
